import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`api/modulemaster/list/`);

      // Transform the data to match component expectations
      const transformedData = response.data.data.map((item: any) => ({
        ...item,
        module_name_perm: item.module_permissions // Map module_permissions to module_name_perm
      }));

      return transformedData;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch modules"
      );
    }
  }
);


export const fetchPermissionsById = createAsyncThunk(
  "permissions/fetchPermissionsById",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `api/permissions/permissions_list/${userId}/`
      );
      return response.data[0];
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

export const submitPermissions = createAsyncThunk(
  "permissions/submitPermissions",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `api/permissions/permissions_list/create/`,
        payload
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
